import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function LinkBreakIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 4.01383C13.8214 1.66206 17.6344 1.66206 19.9862 4.01383C22.3379 6.36559 22.3379 10.1786 19.9862 12.5303L17.3766 15.1399C17.0837 15.4328 16.6089 15.4328 16.316 15.1399C16.0231 14.847 16.0231 14.3721 16.316 14.0792L18.9255 11.4697C20.6915 9.70369 20.6915 6.84047 18.9255 5.07449C17.1595 3.3085 14.2963 3.30851 12.5303 5.07449L9.92078 7.68403C9.62789 7.97692 9.15302 7.97692 8.86012 7.68403C8.56723 7.39114 8.56723 6.91626 8.86012 6.62337L11.4697 4.01383ZM7.68403 8.86012C7.97692 9.15302 7.97692 9.62789 7.68403 9.92078L5.07449 12.5303C3.3085 14.2963 3.3085 17.1595 5.07449 18.9255C6.84047 20.6915 9.70369 20.6915 11.4697 18.9255L14.0792 16.316C14.3721 16.0231 14.847 16.0231 15.1399 16.316C15.4328 16.6089 15.4328 17.0837 15.1399 17.3766L12.5303 19.9862C10.1786 22.3379 6.36559 22.3379 4.01383 19.9862C1.66206 17.6344 1.66206 13.8214 4.01383 11.4697L6.62337 8.86012C6.91626 8.56723 7.39114 8.56723 7.68403 8.86012Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1711 17C19.1711 16.5858 19.5069 16.25 19.9211 16.25H22C22.4142 16.25 22.75 16.5858 22.75 17C22.75 17.4142 22.4142 17.75 22 17.75H19.9211C19.5069 17.75 19.1711 17.4142 19.1711 17ZM17 19.1711C17.4142 19.1711 17.75 19.5069 17.75 19.9211V22C17.75 22.4142 17.4142 22.75 17 22.75C16.5858 22.75 16.25 22.4142 16.25 22L16.25 19.9211C16.25 19.5069 16.5858 19.1711 17 19.1711Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 1.25C7.41421 1.25 7.75 1.58579 7.75 2L7.75 4.07889C7.75 4.4931 7.41421 4.82889 7 4.82889C6.58579 4.82889 6.25 4.4931 6.25 4.07889L6.25 2C6.25 1.58579 6.58579 1.25 7 1.25ZM1.25 7C1.25 6.58579 1.58579 6.25 2 6.25H4.07889C4.4931 6.25 4.82889 6.58579 4.82889 7C4.82889 7.41421 4.4931 7.75 4.07889 7.75H2C1.58579 7.75 1.25 7.41421 1.25 7Z"
      />
    </SvgIcon>
  );
}
